import {
  getListJobsApiV1SendMassJobsGetQueryKey,
  useListJobsApiV1SendMassJobsGet,
} from '#/shared/api/generated/communication/theCargoCommunication'
import type { MassJobSummary } from '#/shared/api/generated/communication/models'

export function activeMassJobsQueryKey(): ReturnType<
  typeof getListJobsApiV1SendMassJobsGetQueryKey
> {
  return getListJobsApiV1SendMassJobsGetQueryKey()
}

/**
 * Bootstraps the active-jobs list with a single fetch (to surface a job that was
 * already running on load / from another tab). The endpoint returns every
 * still-running job of the caller across all channels — SMS, email and call.
 * Live updates after that are driven by socket frames (`bulk_progress` for
 * sends, `power_dialer.updated` for call sessions), which patch this same
 * cache — so there is no recurring poll.
 */
export function useActiveMassJobs(): MassJobSummary[] {
  const { data } = useListJobsApiV1SendMassJobsGet()
  return data?.data ?? []
}
